import {
  Component,
  OnInit,
  AfterViewInit,
  OnDestroy,
  ChangeDetectorRef,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import Chart from 'chart.js/auto';
import * as L from 'leaflet';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import axios from 'src/app/Service/axios';
import {
  RootObject,
  FleetStatusFilter,
  COMM_GROUP_KEYS,
} from './fleet-status.model';
declare let $: any;

interface FleetRowVM {
  item: RootObject;
  badgeCls: string;
  badgeLbl: string;
  lastUpd: string;
  age: string;
  accOn: boolean;
  gpsTxt: string;
}

interface MarkerVM {
  lat: number;
  lng: number;
  color: string;
  popup: string;
}

@Component({
  selector: 'app-fleet-status',
  templateUrl: './fleet-status.component.html',
  styleUrls: ['./fleet-status.component.css'],
})
export class FleetStatusComponent implements OnInit, AfterViewInit, OnDestroy {
  requestForm: FormGroup = this.FormBuilder.group({
    iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),
    strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
  });

  fleetData: RootObject[] = [];
  loading = false;
  errorMsg = '';

  searchText = '';
  statusFilter: FleetStatusFilter = '';

  statusFilterOptions: { value: FleetStatusFilter; label: string }[] = [
    { value: '', label: 'همه وضعیت‌ها' },
    { value: 'Online', label: 'آنلاین' },
    { value: 'Offline', label: 'قطع ارتباط' },
    { value: 'Never', label: 'بدون سابقه' },
    { value: 'NoGPS', label: 'فاقد GPS' },
    { value: 'Disabled', label: 'غیرفعال' },
  ];

  kTotal = 0;
  kActive = 0;
  kToday = 0;
  kOnline = 0;
  kOffline = 0;
  kNever = 0;
  oMoving = 0;
  oStopped = 0;
  oIgnition = 0;
  oNoGps = 0;
  onlinePct = 0;
  validMapCount = 0;
  healthData: { color: string; label: string; value: number }[] = [];
  attentionData: any = [];
  ageData: { label: string; value: number }[] = [];
  tableRows: FleetRowVM[] = [];

  private baseRows: FleetRowVM[] = [];
  private markers: MarkerVM[] = [];
  private tableFilter: FleetStatusFilter = '';
  private charts: any[] = [];
  private map: L.Map | null = null;
  private markerLayer: L.LayerGroup | null = null;

  constructor(
    private _tooltip: NotificationService,
    private FormBuilder: FormBuilder,
    private router: Router,
    private gurdService: GurdServiceService,
    private _otherService: OtherService,
    private cdr: ChangeDetectorRef,
  ) {
    Chart.defaults.font.family = "'vazir', Tahoma, sans-serif";
  }

  ngOnInit(): void {
    this.fetchData();
  }

  ngAfterViewInit(): void {
    this.initMap();
    // When we are inside the Bootstrap modal, after the modal opening animation is finished, the size must be modified
    try {
      if (typeof $ !== 'undefined' && $.fn && ($('#safetyDashboardModal').length)) {
        $('#safetyDashboardModal')
          .off('shown.bs.modal.fleetStatus')
          .on('shown.bs.modal.fleetStatus', () => {
            // The modal is fully opened and the final size is specified
            setTimeout(() => this.refreshMapSize(), 150);
          });
      }
    } catch {}
  }

  ngOnDestroy(): void {
    try {
      if (typeof $ !== 'undefined' && $.fn) {
        $('#safetyDashboardModal').off('shown.bs.modal.fleetStatus');
      }
    } catch {}
    this.destroyCharts();
    this.map?.remove();
    this.map = null;
    this.markerLayer = null;
  }

  // Public method to call from the parent (MapComponent) after the modal is shown
  public refreshMapSize(): void {
    try {
      this.initMap();
      this.renderMap(true);
    } catch {}
  }

  refresh(): void {
    this.fetchData();
  }

  async fetchData() {
    try {
      this.loading = true;
      this.errorMsg = '';
      this._otherService.Showspinner();

      const model = this._otherService.stringNumberToNumber(
        this.requestForm.value,
      );
      const raw = (await axios.post(`GetFleetStatusDashboard`, model)).data;

      let payload: any = raw;
      try {
        if (typeof payload === 'string') payload = JSON.parse(payload);
        if (payload && typeof payload.data === 'string') {
          try {
            payload = JSON.parse(payload.data);
          } catch {}
        }
        if (payload && Array.isArray(payload.data)) payload = payload.data;
        if (payload && Array.isArray(payload.Table)) payload = payload.Table;
      } catch {
        payload = raw;
      }

      if (payload?.ISSessionExpired == true) {
        this._tooltip.showError('نشست کاربری شما منقضی شده است');
        this._otherService.removeLocalStorage();
        this.router.navigate(['login'], {
          queryParams: { error: 'GetFleetStatusDashboard' },
        });
        return;
      }

      if (payload?.iResult == 0) {
        throw new Error(payload.strError || 'خطا در دریافت اطلاعات');
      }

      if (!Array.isArray(payload)) {
        throw new Error('فرمت پاسخ API آرایه JSON نیست.');
      }

      this.fleetData = payload;
      this.refreshDerived();
      this.cdr.detectChanges();
      setTimeout(() => this.renderAll(), 60);
    } catch (err: any) {
      console.error('[FleetStatus] fetchData error', err);
      this.errorMsg =
        'خطا در دریافت اطلاعات: ' + (err?.message || 'خطای نامشخص');
      this._tooltip.showError('خطا در دریافت اطلاعات وضعیت ناوگان');
    } finally {
      this.loading = false;
      this._otherService.nonespinner();
      try {
        this.cdr.detectChanges();
      } catch {}
    }
  }

  private bool(v: any): boolean {
    return (
      v === true || v === 1 || v === '1' || String(v).toLowerCase() === 'true'
    );
  }

  private num(v: any): number {
    return v === null || v === undefined || v === '' ? 0 : Number(v);
  }

  private txt(v: any): string {
    return v === null || v === undefined || v === '' ? '-' : String(v);
  }

  private formatDate(v: any): string {
    if (!v) return '-';
    const d = new Date(v);
    if (isNaN(d.getTime())) return String(v);
    return d.toLocaleString('fa-IR-u-nu-latn');
  }

  private escapeHtml(v: any): string {
    return String(v ?? '').replace(
      /[&<>"']/g,
      (m) =>
        ({
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#039;',
        })[m] as string,
    );
  }

  // ---------- پیش‌محاسبه یک‌باره همه مشتقات ----------
  private refreshDerived(): void {
    const D = this.fleetData;
    const is = (fn: (x: RootObject) => boolean) => D.filter(fn).length;

    this.kTotal = D.length;
    this.kActive = is((x) => this.bool(x.bActive));
    this.kToday = is((x) => this.bool(x.bActiveToday));
    this.kOnline = is((x) => this.bool(x.bOnline));
    this.kNever = is(
      (x) =>
        x.strCommunicationGroup === 'Never' ||
        x.strOperationalStatus === 'NeverConnected',
    );
    this.kOffline = is(
      (x) =>
        this.bool(x.bActive) &&
        this.bool(x.bHasGPS) &&
        !this.bool(x.bOnline) &&
        x.strCommunicationGroup !== 'Never',
    );
    this.oMoving = is((x) => x.strOperationalStatus === 'Moving');
    this.oStopped = is((x) => x.strOperationalStatus === 'Stopped');
    this.oIgnition = is((x) => x.strOperationalStatus === 'IgnitionOnStopped');
    this.oNoGps = is((x) => !this.bool(x.bHasGPS));
    this.onlinePct = this.kTotal ? (this.kOnline / this.kTotal) * 100 : 0;

    const groups: Record<string, number> = Object.fromEntries(
      COMM_GROUP_KEYS.map((k) => [k, 0]),
    );
    D.forEach((x) => {
      if (groups[x.strCommunicationGroup] !== undefined) {
        groups[x.strCommunicationGroup]++;
      }
    });

    this.healthData = [
      { color: '#2bd486', label: 'آنلاین', value: groups['Online'] },
      {
        color: '#f5c84c',
        label: 'قطع کمتر از 3 ساعت',
        value: groups['15m-1h'] + groups['1h-3h'],
      },
      { color: '#ff914d', label: 'قطع 3 تا 24 ساعت', value: groups['3h-24h'] },
      {
        color: '#ff5d6c',
        label: 'قطع بیش از یک روز',
        value: groups['1d-3d'] + groups['3d-7d'] + groups['Over7d'],
      },
      { color: '#718096', label: 'بدون سابقه', value: groups['Never'] },
    ];

    this.attentionData = [
      {
        title: 'قطع بیش از 7 روز',
        count: groups['Over7d'],
        filter: 'Over7d' as FleetStatusFilter,
        color: '#ff5d6c',
      },
      {
        title: 'قطع 3 تا 7 روز',
        count: groups['3d-7d'],
        filter: '3d-7d' as FleetStatusFilter,
        color: '#ff914d',
      },
      {
        title: 'قطع 1 تا 3 روز',
        count: groups['1d-3d'],
        filter: '1d-3d' as FleetStatusFilter,
        color: '#f5c84c',
      },
      {
        title: 'بدون سابقه ارتباط',
        count: groups['Never'],
        filter: 'Never' as FleetStatusFilter,
        color: '#718096',
      },
      {
        title: 'غیرفعال توسط مدیر',
        count: is((x) => !this.bool(x.bActive)),
        filter: 'Disabled' as FleetStatusFilter,
        color: '#8d73ff',
      },
      {
        title: 'فاقد GPS',
        count: this.oNoGps,
        filter: 'NoGPS' as FleetStatusFilter,
        color: '#36d7ff',
      },
    ];

    this.ageData = [
      { label: '< 15 دقیقه', value: groups['Online'] },
      { label: '15دقیقه-1ساعت', value: groups['15m-1h'] },
      { label: '1-3 ساعت', value: groups['1h-3h'] },
      { label: '3-24 ساعت', value: groups['3h-24h'] },
      { label: '1-3 روز', value: groups['1d-3d'] },
      { label: '3-7 روز', value: groups['3d-7d'] },
      { label: '> 7 روز', value: groups['Over7d'] },
      { label: 'بدون سابقه', value: groups['Never'] },
    ];

    const badgeOf = (x: RootObject) => {
      if (!this.bool(x.bActive)) return { cls: 'muted', lbl: 'غیرفعال' };
      if (!this.bool(x.bHasGPS)) return { cls: 'muted', lbl: 'فاقد GPS' };
      if (x.strCommunicationGroup === 'Never')
        return { cls: 'muted', lbl: 'بدون سابقه' };
      if (this.bool(x.bOnline)) return { cls: 'online', lbl: 'آنلاین' };
      if (['15m-1h', '1h-3h'].includes(x.strCommunicationGroup))
        return { cls: 'warn', lbl: 'قطع کوتاه' };
      return { cls: 'offline', lbl: 'قطع ارتباط' };
    };

    this.baseRows = D.map((x) => {
      const badge = badgeOf(x);
      return {
        item: x,
        badgeCls: badge.cls,
        badgeLbl: badge.lbl,
        lastUpd: this.formatDate(x.dtLastupdate),
        age: this.ageText(x),
        accOn: this.bool(x.bOnOff),
        gpsTxt: this.bool(x.bHasGPS)
          ? this.txt(x.strGPS_strComment)
          : 'بدون GPS',
      };
    }).sort(
      (a, b) =>
        (Number(a.item.iAttentionPriority) || 0) -
        (Number(b.item.iAttentionPriority) || 0),
    );
    this.applyTableFilter();

    this.markers = [];
    D.forEach((x) => {
      const c = this.coords(x);
      if (!c) return;
      const color = this.markerColor(x);
      const rows: [string, string][] = [
        ['سرعت', `<b dir="ltr">${this.num(x.iSpeed)} km/h</b>`],
        [
          'وضعیت',
          `<b style="color:${color}">${this.escapeHtml(x.strCommunicationStatus)}</b>`,
        ],
        [
          'آخرین ارتباط',
          `<b>${this.escapeHtml(this.formatDate(x.dtLastupdate))}</b>`,
        ],
        ['گروه', `<b>${this.escapeHtml(x.strMobileGroup_strComment)}</b>`],
      ];
      this.markers.push({
        lat: c[0],
        lng: c[1],
        color,
        popup:
          `<div dir="rtl" style="min-width:215px;font-family:Tahoma,Arial,sans-serif">` +
          `<div style="font-size:15px;font-weight:800;margin-bottom:2px">${this.escapeHtml(x.strVehicleNo)}</div>` +
          `<div style="font-size:11px;color:#9fb1c6;margin-bottom:8px">${this.escapeHtml(x.strFullName)} • ${this.escapeHtml(x.strMobileType_strComment)}</div>` +
          `<div style="border-top:1px solid #29405b;margin-bottom:6px"></div>` +
          rows
            .map(
              ([l, v]) =>
                `<div style="display:flex;justify-content:space-between;align-items:center;font-size:12px;padding:3px 0"><span style="color:#9fb1c6">${l}</span>${v}</div>`,
            )
            .join('') +
          `</div>`,
      });
    });
    this.validMapCount = this.markers.length;
  }

  // ---------- جدول ----------
  onStatusFilterChange(): void {
    this.tableFilter = '';
    this.applyTableFilter();
  }

  setAttentionFilter(f: FleetStatusFilter): void {
    this.tableFilter = f;
    if (f === 'Never' || f === 'NoGPS' || f === 'Disabled') {
      this.statusFilter = f;
    } else {
      this.statusFilter = '';
    }
    this.applyTableFilter();
    this.cdr.detectChanges();
    setTimeout(
      () =>
        document
          .getElementById('fleetTableCard')
          ?.scrollIntoView({ behavior: 'smooth', block: 'center' }),
      60,
    );
  }

  applyTableFilter(): void {
    const qv = (this.searchText || '').trim().toLowerCase();
    const f = this.statusFilter || this.tableFilter;
    this.tableRows = this.baseRows.filter(({ item: x }) => {
      let ok = true;
      if (qv) {
        ok = [
          x.strVehicleNo,
          x.strFullName,
          x.strUnitID,
          x.strMobileType_strComment,
          x.strMobileGroup_strComment,
          x.strMobileDomain_strComment,
        ]
          .map((v) => this.txt(v))
          .join(' ')
          .toLowerCase()
          .includes(qv);
      }
      if (f === 'Online') ok = ok && this.bool(x.bOnline);
      else if (f === 'Offline')
        ok =
          ok &&
          this.bool(x.bActive) &&
          this.bool(x.bHasGPS) &&
          !this.bool(x.bOnline) &&
          x.strCommunicationGroup !== 'Never';
      else if (f === 'Never') ok = ok && x.strCommunicationGroup === 'Never';
      else if (f === 'NoGPS') ok = ok && !this.bool(x.bHasGPS);
      else if (f === 'Disabled') ok = ok && !this.bool(x.bActive);
      else if (f === 'Over7d' || f === '3d-7d' || f === '1d-3d')
        ok = ok && x.strCommunicationGroup === f;
      return ok;
    });
  }

  private coords(x: RootObject): [number, number] | null {
    if (x.dLatitude === null || x.dLatitude === undefined || x.dLatitude === '')
      return null;
    if (
      x.dLongitude === null ||
      x.dLongitude === undefined ||
      x.dLongitude === ''
    )
      return null;
    const lat = Number(x.dLatitude);
    const lng = Number(x.dLongitude);
    if (!Number.isFinite(lat) || !Number.isFinite(lng) || !lat || !lng)
      return null;
    if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return null;
    return [lat, lng];
  }

  private ageText(x: RootObject): string {
    if (
      x.iMinutesSinceLastUpdate === null ||
      x.iMinutesSinceLastUpdate === undefined
    )
      return '-';
    const m = this.num(x.iMinutesSinceLastUpdate);
    if (m < 60) return `${m} دقیقه`;
    if (m < 1440) return `${Math.floor(m / 60)} ساعت`;
    return `${Math.floor(m / 1440)} روز`;
  }

  private markerColor(x: RootObject): string {
    if (x.strOperationalStatus === 'Moving') return '#2bd486';
    if (
      x.strOperationalStatus === 'Stopped' ||
      x.strOperationalStatus === 'IgnitionOnStopped'
    )
      return '#4b8dff';
    if (x.strCommunicationGroup === 'Over7d') return '#ff5d6c';
    if (x.strOperationalStatus === 'Offline') return '#ff914d';
    return '#718096';
  }

  private renderAll(): void {
    this.initMap();
    this.renderCharts();
    this.renderMap();
  }

  private canvas(id: string): HTMLCanvasElement | null {
    return document.getElementById(id) as HTMLCanvasElement | null;
  }

  private destroyCharts(): void {
    this.charts.forEach((c) => {
      try {
        c.destroy();
      } catch {}
    });
    this.charts = [];
  }

  private renderCharts(): void {
    this.destroyCharts();
    if (!this.fleetData.length) return;

    const healthEl = this.canvas('healthChart');
    if (healthEl) {
      this.charts.push(
        new Chart(healthEl, {
          type: 'doughnut',
          data: {
            labels: this.healthData.map((r) => r.label),
            datasets: [
              {
                data: this.healthData.map((r) => r.value),
                backgroundColor: this.healthData.map((r) => r.color),
                borderWidth: 0,
              },
            ],
          },
          options: {
            maintainAspectRatio: false,
            cutout: '72%',
            plugins: { legend: { display: false } },
          } as any,
        }),
      );
    }

    const ageEl = this.canvas('ageChart');
    if (ageEl) {
      this.charts.push(
        new Chart(ageEl, {
          type: 'bar',
          data: {
            labels: this.ageData.map((b) => b.label),
            datasets: [
              {
                data: this.ageData.map((b) => b.value),
                backgroundColor: [
                  '#2bd486',
                  '#7fdc70',
                  '#f5c84c',
                  '#ffad4d',
                  '#ff914d',
                  '#ff755b',
                  '#ff5d6c',
                  '#718096',
                ],
                borderRadius: 6,
              },
            ],
          },
          options: {
            maintainAspectRatio: false,
            scales: {
              x: {
                ticks: { color: '#9fb1c6', font: { size: 10 } },
                grid: { display: false },
              },
              y: {
                beginAtZero: true,
                ticks: {
                  color: '#9fb1c6',
                  font: { size: 10 },
                  precision: 0,
                },
                grid: { color: 'rgba(120,150,180,.12)' },
              },
            },
            plugins: { legend: { display: false } },
          } as any,
        }),
      );
    }
  }

  private initMap(): void {
    try {
      const el = document.getElementById('fleetMap');
      if (!el) return;
      if (this.map) {
        if (this.map.getContainer() === el) return;
        this.map.remove();
        this.map = null;
        this.markerLayer = null;
      }
      this.map = L.map('fleetMap', { zoomControl: true }).setView(
        [32.4, 53.7],
        5,
      );
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; OpenStreetMap contributors',
      }).addTo(this.map);
      this.markerLayer = L.layerGroup().addTo(this.map);
    } catch (err) {
      console.error('[FleetStatus] initMap error', err);
    }
  }

  private renderMap(forceFit = false): void {
    if (!this.map || !this.markerLayer) return;
    // مهم: اول سایز واقعی کانتینر را به Leaflet بفهمان، بعد مارکر/fitBounds
    this.map.invalidateSize();
    this.markerLayer.clearLayers();
    const bounds: [number, number][] = [];
    this.markers.forEach((m) => {
      const icon = L.divIcon({
        className: '',
        html: `<div class="map-marker" style="background:${m.color}"></div>`,
        iconSize: [13, 13],
        iconAnchor: [6, 6],
      });
      L.marker([m.lat, m.lng], { icon })
        .bindPopup(m.popup)
        .addTo(this.markerLayer as L.LayerGroup);
      bounds.push([m.lat, m.lng]);
    });
    if (bounds.length && (forceFit || !this.map.getBounds?.().isValid())) {
      try {
        this.map.fitBounds(bounds, { padding: [25, 25], maxZoom: 12 });
      } catch {}
    } else if (bounds.length && forceFit) {
      try {
        this.map.fitBounds(bounds, { padding: [25, 25], maxZoom: 12 });
      } catch {}
    }
    // انیمیشن fade مودال ~150-300ms طول می‌کشد؛ چند بار invalidate تا تایل‌ها کامل لود شوند
    [100, 300, 600].forEach((d) =>
      setTimeout(() => {
        try {
          this.map?.invalidateSize();
          if (forceFit && bounds.length) {
            this.map?.fitBounds(bounds as any, {
              padding: [25, 25],
              maxZoom: 12,
            } as any);
          }
        } catch {}
      }, d),
    );
  }
  
}
